@if (column.includes('RatedLife')) {
  <div class="row slider-container">
    <div id="Dali253M-ratedMedian-text" class="col-3 label startupLabel">
    Rated median useful life of luminaire</div>
    <div class="col-4 d-flex align-items-center">
      <input id="Dali253M-ratedMedian-input" type="text" [value]="ngModelval['RatedLife']"
        (input)="RatedLifevalueChanged($event.target.value,'RatedLife')" (keypress)="numberOnly($event)"  (paste)="blockNonNumericPaste($event)"
        [ngClass]="{'myStyle': inputError['RatedLife']===true}"
        class="input-text form-control signifyBookmd custom-inputbox textbox-standard" />
        <p id="Dali253M-ratedMedian-unit" class="signifyBookmd unit mb-0 ml-2">
          x 1000 h
        </p>
      </div>
    </div>
  }
  @if (column.includes('ReferenceTemperature')) {
    <div class="row slider-container">
      <div id="Dali253M-temperature-text" class="col-3 label startupLabel">
        <span>Internal control gear reference</span>
        <p>temperature</p>
      </div>
      <div class="col-4 d-flex align-items-center">
        <input id="Dali253M-temperature-input" type="text" [value]="ngModelval['ReferenceTemperature']"
          (input)="ReferenceTemperaturevalueChanged($event.target.value,'ReferenceTemperature')" (keypress)="numbersAll($event)"  (paste)="blockNonNumericPaste($event)"
          [ngClass]="{'myStyle': inputError['ReferenceTemperature']===true}"
          class="input-text form-control signifyBookmd custom-inputbox textbox-standard" />
          <p id="Dali253M-temperature-unit" class="signifyBookmd unit mb-0 ml-2">
            &deg;C
          </p>
        </div>
      </div>
    }
    @if (column.includes('RatedStarts')) {
      <div class="row slider-container">
        <div id="Dali253M-ratedStarts-text" class="col-3 label startupLabel">
        Rated median useful light source start</div>
        <div class="col-3 d-flex align-items-center">
          <input id="Dali253M-ratedStarts-input" type="text" [value]="ngModelval['RatedStarts']" (input)="RatedStartsvalueChanged($event.target.value,'RatedStarts')"
            (keypress)="numberOnly($event)"  (paste)="blockNonNumericPaste($event)" [ngClass]="{'myStyle': inputError['RatedStarts']===true}"
            class="input-text form-control signifyBookmd custom-inputbox textbox-standard" />
            <p id="Dali253M-ratedStarts-unit" class="signifyBookmd unit mb-0 ml-2">
              x 100
            </p>
          </div>
        </div>
      }
